import { Box, IconButton } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import GameCastLoader from './GameCastLoader';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

import { useMytaverseEvent } from '@core/dashboard/providers';
import { useEventContext } from '@providers/EventProvider';
import { useConference } from '../Dolby';
import { useStyles } from './styles';

const GameCast = () => {
  const {
    currentRoom,
    setSharingWindowFullscreen,
    sharingWindowFullsceen,
    handleMinimizeSharingScreen,
    isMinimizedScreenSharing,
  } = useMytaverseEvent();
  const classes = useStyles();

  const { screenMediaStreams } = useConference();
  const { isEventRun } = useEventContext();

  const showGamecastLoader = !currentRoom || !isEventRun;

  if (showGamecastLoader) {
    return <GameCastLoader />;
  }

  return (
    <Box>
      {screenMediaStreams.length && !isMinimizedScreenSharing ? (
        <>
          <IconButton
            sx={classes.fullscreen}
            id="gameFull"
            onClick={setSharingWindowFullscreen}
          >
            {sharingWindowFullsceen ? (
              <FullscreenExitIcon />
            ) : (
              <FullscreenIcon />
            )}
          </IconButton>
          <IconButton
            sx={classes.fullscreenCollapse}
            id="gameCollapse"
            onClick={handleMinimizeSharingScreen}
          >
            <CloseFullscreenIcon />
          </IconButton>
        </>
      ) : null}
    </Box>
  );
};

export default GameCast;
